
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giftcards",
      function () {
        return require("private-next-pages/giftcards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/giftcards"])
      });
    }
  